import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

export const createPaymentMethod = (data, callback, errorCallBack) => {
   
  return async (dispatch) => {
    
    formDataCommonFunction(data,apiConstants.PAYMENT_GATEWAY.CREATE_PAYMENT_METHOD)
      .then((response) => {
        callback && callback(response)
      
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}